import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Error } from '../components';
import qs from 'qs';

class ErrorPage extends Component {
  queryString(key) {
    return qs.parse(this.props.location.search.substr(1))[key];
  }

  render() {
    return <Error code={this.queryString('e')} />;
  }
}

ErrorPage.propTypes = {
  params: PropTypes.object
};

export default ErrorPage;
